import React from 'react';
import { useAdmin } from 'hooks';

/**
 * @typedef {Object} CalendarCellShape
 * @property {number} width
 * @property {number} height
 * @property {import('constants/calendarSettings').Margin} margin
 */

/**
 * @param {Object} props
 * @param {ReturnType<typeof import('constants/calendarSettings').getCalendarSettings>} props.calendarSettings
 * @param {boolean} [props.showDebugGuides]
 * @param {CalendarCellShape} [props.cellShape]
 * @returns {React.ReactElement|null}
 */
const DaySize = ({ calendarSettings, showDebugGuides, cellShape = calendarSettings.DayContentShape }) => {
  const admin = useAdmin();
  if (!admin || !showDebugGuides) return null;
  return (
    <rect
      x={cellShape.margin.left}
      y={cellShape.margin.top}
      width={Math.max(0, cellShape.width - cellShape.margin.left - cellShape.margin.right)}
      height={Math.max(0, cellShape.height - cellShape.margin.top - cellShape.margin.bottom)}
      fillOpacity="0"
      stroke="grey"
      strokeOpacity="0.3"
      strokeWidth="1"
      strokeDasharray="3,3"
    />
  );
};

export default DaySize;
